import React, { useState, useEffect } from "react";
import { MobileStepper } from "@mui/material";
import Cookies from "js-cookie";
import { Modal } from "antd";

const VerifyEmail = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const [email, setEmail] = useState("");
  const handleSubmitEmail = (event) => {
    event.preventDefault();
    setIsLoading(true);

    fetch("https://www.smart-lend.com/api/auth/register/emailResend", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("token"),
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to resend email");
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  const [modalIsOpen, setModalIsOpen] = useState(false);

  let semail = "";
  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      const response = await fetch(
        "https://www.smart-lend.com/api/auth/register/viewUser",
        options
      );
      const json = await response.json();
      const email = json.email;
      if (email) {
        console.log(email);
        setEmail(email);
        semail = email;
      }
      setData(response);
    }
    fetchData();
  }, []);

  useEffect(() => {
    // Function to fetch data from the API
    const fetchData2 = async () => {
      if (!modalIsOpen) {
        try {
          console.log(semail);
          const response = await fetch(
            "https://www.smart-lend.com/api/registration/checkEmailVerifiedOrNot",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
              },
              body: JSON.stringify({ email: semail }),
            }
          );
          if (response.status === 200) {
            Cookies.remove("token");
            setModalIsOpen(true);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };

    // Initial fetch when the component mounts
    fetchData2();

    // Set up the interval to fetch data every 10 seconds
    const intervalId = setInterval(() => {
      fetchData2();
    }, 10000); // 10000ms = 10 seconds

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []); // Empty dependency array ensures this runs only once on mount

  return (
    <>
      <Modal
        open={modalIsOpen}
        onCancel={() => {
          setModalIsOpen(false);
          window.location.href = "https://smart-lend.com/auth/signin";
        }}
        footer={null}
      >
        <div
          style={{
            color: "#0e5aa5",
            fontWeight: 800,
            fontFamily: "Manrope, sans-serif",
            fontSize: 22,
          }}
        >
          Email Verified
        </div>
        <div
          style={{
            color: "lighgrey",
            fontWeight: 400,
            fontFamily: "Manrope, sans-serif",
            fontSize: 13,
          }}
        >
          Your registered email has been verified, you may proceed to login to
          the account.
        </div>
        <button
          className="btn-submit-verify"
          style={{ marginTop: "10px" }}
          onClick={(e) => {
            e.preventDefault();
            window.location.href = "https://smart-lend.com/auth/signin";
          }}
        >
          Proceed
        </button>
      </Modal>
      <React.Fragment>
        <div className="auth-header auth-header-verify-step">
          <h3 className="auth-header-title-verify">
            Check your inbox to continue.
          </h3>
          <p className="auth-header-subtitle-verify">
            We sent a verification email to the address below. Once verified,
            the account can continue through onboarding.
          </p>
        </div>
        <div className="auth-body auth-body-verify-step">
          <div className="auth-status-card">
            <label>Verification sent to</label>
            <div className="auth-email-pill">
              <span>{email || "your registered email"}</span>
              <span>Pending</span>
            </div>
          </div>
          <form
            className="auth-form-validation auth-verify-actions"
            onSubmit={handleSubmitEmail}
          >
            <div className="btn-position">
              <button
                type="submit"
                className="btn-submit-verify"
                disabled={isLoading}
              >
                {isLoading ? "Sending..." : "Resend email"}
              </button>
            </div>
            <button
              type="button"
              className="btn-submit-default auth-secondary-button"
              onClick={() => {
                window.location.href = "https://wa.me/6587853373";
              }}
            >
              Contact support
            </button>
          </form>
          <div className="auth-stepper-row">
            <MobileStepper
              variant="dots"
              steps={6}
              position="static"
              activeStep={1}
              sx={{ maxWidth: 400, flexGrow: 1 }}
            />
          </div>
        </div>
      </React.Fragment>
    </>
  );
};

export default VerifyEmail;
